<script>
  export let idUnico = 'siglas';
  export let content;

  content = content.replaceAll('Queer', '<i>Queer</i>');

  let items = content.split(';;');

  items = items.slice(0, -1);

  let items_1 = [];
  let items_2 = [];
  let index_items;

  items.forEach((item, index) => {
    index_items = item.search(' - ');
    items_1[index] = item.substring(0, index_items).trim();
    items_2[index] = item.substring(index_items + 3, item.length).trim();
  });
</script>

<div class="container" id={idUnico}>
  <h2>Siglas</h2>
  <!-- <div class="grid-wrapper"> -->
  <div class="grid-siglas">
    {#each items as items, index}
      <div class="column-1">
        <p>{@html items_1[index]}</p>
      </div>
      <div>
        <p>{@html items_2[index]}</p>
      </div>
    {/each}
  </div>
  <!-- </div> -->
</div>

<style>
  .grid-siglas {
    display: grid;
    grid-template-columns: 20% 1fr;
    padding: 0;
    column-gap: 20px;
    row-gap: 20px;
    margin-top: 1rem;
  }

  .grid-siglas p {
    font-size: 16px;
    padding: 0;
    margin: 0;
    line-height: normal;
  }

  .grid-siglas div {
    display: grid;
    height: 100%;
    align-items: center;
  }

  .grid-siglas div.column-1 {
    justify-items: end;
  }

  .grid-siglas div.column-1 p {
    font-weight: 600;
  }

  @media (max-width: 800px) {
    .grid-siglas {
      grid-template-columns: 30% 1fr;
      row-gap: 15px;
    }
    .grid-siglas div {
      padding: 0;
    }
    .grid-siglas {
      grid-auto-rows: unset;
    }
  }
</style>
